<template>
    <div>
        <!--统一安全验证的弹窗-->
        <safeVerify
        ref="safeCheck"
        pageType="h5"
        :checkVisible="checkVisible"
        @updateCheckVisible="updateCheckVisible"
        @handleOperate="handleOperate"
        />
    </div>
</template>
<script setup>
import safeVerify from '@/components/safeVerify';
import { onMounted, computed, ref } from 'vue';
import {useRouter} from 'vue-router';

const router = useRouter();
const safeCheck = ref('safeCheck');

function changeState (item) {
  if (item !== 'bindEmail') {
    operateType.value = item;
    safeCheck.value.operateState(item);
  }
}
onMounted(() => {
  let param = router.currentRoute.value.query;
  safeCheck.value.operateState(param.State);
});

const checkVisible = ref(false);
function updateCheckVisible (val) {
  checkVisible.value = val;
}
function handleOperate (item) {
  router.push({ name: item });
}
</script>
<style scoped>

</style>
